// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wlqV","inner":"styles_inner__2Qh5B","right":"styles_right__3iUMr","close":"styles_close__3EN-x","footer":"styles_footer__6n9vs"};